import { render, staticRenderFns } from "./BaseTLGridItem.vue?vue&type=template&id=b37d00e6&"
import script from "./BaseTLGridItem.vue?vue&type=script&lang=ts&"
export * from "./BaseTLGridItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports